module.exports = __webpack_public_path__ + "assets/sushi_disabled-4b2cbe.svg";